import { render, staticRenderFns } from "./IconDocumentDuplicateOutline.vue?vue&type=template&id=019d69d5"
import script from "./IconDocumentDuplicateOutline.vue?vue&type=script&lang=js"
export * from "./IconDocumentDuplicateOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports